// eventLoader.ts
import { LoaderFunctionArgs } from "react-router-dom";
import ApiClient from "services/api-client";
import { USER_TOKEN, hostURL } from "utils/helper/states";

export const providerLoader = async ({ params }: LoaderFunctionArgs) => {
  const { id } = params;
  const uri = `${hostURL}/api/services/get-service-provider-details/${id}`;
  const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    token = localStorage.getItem(USER_TOKEN);
  const res = await fetch(uri, {
    headers: token == null ? headers : { ...headers, Authorization: token },
  });
  if (res.status === 404) {
    throw new Response("Not Found", { status: 404 });
  }
  const data = await res.json();
  if (data.success != null) {
    if (data.statusCode != null && !data.success) {
      console.log(data);
      throw new Response(data.message, { status: data.statusCode });
    }
    if (data.success && data.data != null) {
      return data.data;
    }
  }
  return null;
};

export const houseLoader = async ({ params }: LoaderFunctionArgs) => {
  const { id } = params;
  const uri = `${hostURL}/api/agents/get-house/${id}`;
  const token = localStorage.getItem(USER_TOKEN);
  const res = await ApiClient.get(uri, token!);
  console.log(res);
  if (res.success) {
    return res.data;
  }
  throw new Response(res.message, { status: res.statusCode });
};
